module.exports = __webpack_public_path__ + "img/Patent_1.12e11073.png";